import http from "../http-common";

class DesvinculadoService {

    ingresar(data) {
        return http.post("/desvinculado",data);
    }

    getAll() {
        return http.get("/desvinculado");
    }

    delete(id) {
        return http.delete(`/desvinculado/${id}`);
    }
}

export default new DesvinculadoService();